import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as BackArrow } from "../../../Icons/BorderBackArrow.svg";
import { ReactComponent as AddBuildingIcon } from "../../../Icons/AddBuilding.svg";
import { ReactComponent as Close } from "../../../Icons/BorderAlertClose.svg";
import { ReactComponent as UploadIcon } from "../../../Icons/UploadIcon.svg";
import { ReactComponent as RefreshIcon } from "../../../Icons/Refresh.svg";
import { ReactComponent as DownloadIcon } from "../../../Icons/DownloadIcon.svg";
import {
  ErrorTypography,
  PrimaryTypography,
  SecondaryTypography,
  StyledSecondaryTypography,
  StyledTypography,
} from "../../../Theme";
import {
  Box,
  Button,
  TextField,
  Typography,
  Modal,
  Grid,
  Stack,
  Chip,
  Container,
} from "@mui/material";
import {
  setActiveStep,
  updatePropertyDetailsCompletedSteps,
  setPropertySliceToNull,
  setNestedStep,
} from "../../../Redux/Feature/PropertyDetails/propertyDetailsSlice";
import { useDispatch } from "react-redux";
import { ReactComponent as EditBuilding } from "../../../Icons/EditBuilding.svg";
import { ReactComponent as ExcelIcon } from "../../../Icons/Excel.svg";
import moment from "moment";
import { changeUserData } from "../../../Utils";
import Dropzone from "react-dropzone";
import axiosInstance from "../../../Redux/AxiosInstance";
import { useSelector } from "react-redux";
import { showToast } from "../../../CommonComponents/Toaster";
import { saveAs } from "file-saver";
import { PostLoaderModal } from "../../../CommonComponents/modal";

const ReviewBuilding = ({ setDisplayScreen }) => {
  const { propertyId, propertyCompletedStep } = useSelector(
    (state) => state.PropertyDetails
  );
  const [postLoader, SetPostLoader] = useState(false);
  const [buildingData, setBuildingData] = useState([]);
  const [editModalName, setEditModalName] = useState(false);
  const [editData, setEditData] = useState({ id: "", building: "" });
  const [inputError, setInputError] = useState("");
  const [errId, setErrorId] = useState(null);
  const [xlsError, setXlsError] = useState("");
  const [levelTrigger, setLevelTrigger] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const fileInputRef = useRef(null);
  const [currentBuildingId, setCurrentBuildingId] = useState(null);
  const dispatch = useDispatch();

  const allObjectsContainImportFilePath = () => {
    return buildingData.every((building) => building.import_file_path);
  };

  const handleContinue = () => {
    if (allObjectsContainImportFilePath()) {
      SetPostLoader(true);
      if (changeUserData(2)) {
        dispatch(
          updatePropertyDetailsCompletedSteps({ propertyId, completed_step: 2 })
        );
      } else if (!changeUserData(2)) {
        dispatch(setActiveStep(2));
        dispatch(setPropertySliceToNull());
        dispatch(setNestedStep(0));
      }
    } else {
      showToast("Please import files for all buildings", "error");
    }
  };

  useEffect(() => {
    if (propertyCompletedStep != null) {
      if (propertyCompletedStep.success === true) {
        changeUserData(2, "change");
        dispatch(setActiveStep(2));
        dispatch(setPropertySliceToNull());
        dispatch(setNestedStep(0));
      }
    }
  }, [propertyCompletedStep]);

  const getBuilding = () => {
    SetPostLoader(true);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}property/${propertyId}/building?pagination=false`
      )
      .then((res) => {
        setBuildingData(res?.data?.data?.property_buildings);
        SetPostLoader(false);
      })
      .catch((err) => {
        console.error(err);
        SetPostLoader(false);
        showToast("Something went wrong! Please try again later.");
      });
  };

  useEffect(() => {
    getBuilding();
  }, []);

  const handlePreviewXls = async (id) => {
    const buildingName = buildingData?.find((itm) => itm?.id === id);
    setPreviewData(buildingName);
    levelopen();
  };

  const levelopen = () => {
    setLevelTrigger(true);
  };

  const handleExistsEmpty = (id) => {
    setCurrentBuildingId(id);
    fileInputRef.current.click();
  };

  const handleEditBuildingName = (name, id) => {
    setEditData({ id: id, building: name });
    setEditModalName(true);
  };
  const handleEmptyReplace = (id) => {
    setCurrentBuildingId(id);
    fileInputRef.current.click();
  };
  const handleFileInputChange = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      onDrop(currentBuildingId, files);
    }
  };
  const onDrop = (id, acceptedFiles) => {
    const buildingName = buildingData?.find((itm) => itm?.id === id);
    const updatedBuildingData = buildingData.map((building) => {
      if (building.id === id) {
        return {
          ...building,
          files: acceptedFiles,
        };
      }
      return building;
    });
    setBuildingData(updatedBuildingData);
    uploadFile(id, acceptedFiles, buildingName?.building_name);
  };

  const uploadFile = (id, files, name) => {
    SetPostLoader(true);
    const formData = new FormData();
    formData.append("building_array_list[0][building_name]", name);
    formData.append("building_array_list[0][id]", id);
    formData.append("building_array_list[0][file]", files[0]);
    axiosInstance
      .post(
        `${process.env.REACT_APP_API_URL}property/${propertyId}/building/import`,
        formData
      )
      .then((res) => {
        getBuilding();
        SetPostLoader(false);
        showToast("XLS Template upload successfully");
      })
      .catch((err) => {
        SetPostLoader(false);
        setErrorId(id);
        const importErrors = err?.response?.data?.data?.import_validation_error;
        if (importErrors) {
          const errorMessages = Object.keys(importErrors).map((row, index) => {
            const rowData = importErrors[row];
            const formattedMessage = `Row ${index + 1}: ${rowData.join(" , ")}`;
            return formattedMessage;
          });
          setXlsError(errorMessages.join("\n"));
        } else {
          setXlsError("An error occurred during file upload.");
        }
      });
  };

  const handleEditConfirm = () => {
    if (!editData.building.trim()) {
      setInputError("Please Enter the building name");
    } else {
      SetPostLoader(true);
      const formData = new FormData();
      formData.append(
        "building_array_list[0][building_name]",
        editData.building
      );
      formData.append("building_array_list[0][id]", editData.id);

      axiosInstance
        .post(
          `${process.env.REACT_APP_API_URL}property/${propertyId}/building/import`,
          formData
        )
        .then((res) => {
          getBuilding();
          SetPostLoader(false);
          setEditModalName(false);
        })
        .catch((err) => {
          const validationError =
            err.response?.data?.data?.validation_error[
              "building_array_list.0.building_name"
            ];
          SetPostLoader(false);
          if (validationError) {
            setInputError(validationError);
          } else {
            showToast("Something went wrong! Please try again later.", "error");
            setEditModalName(false);
          }
        });
    }
  };

  return (
    <>
      {postLoader && <PostLoaderModal />}
      <BackArrow
        onClick={() => setDisplayScreen("addBuilding")}
        style={{ marginBottom: "16px", cursor: "pointer" }}
      />
      {levelTrigger && (
        <Modal open={true}>
          <Container
            sx={{
              // position: "absolute",
              border: "none",
              width: "100%",
              // height: "90%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                backgroundColor: "#FFFFFF",
                // width: "100%",
                borderRadius: "8px",
              }}
            >
              <Box
                sx={{
                  padding: "16px 24px 16px 24px",
                  borderBottom: "1px solid #F3F4F6",
                  borderRadius: "8px 8px 0px 0px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <PrimaryTypography>
                  {previewData?.building_name}
                </PrimaryTypography>
                <Close
                  style={{ cursor: "pointer" }}
                  onClick={() => setLevelTrigger(false)}
                />
              </Box>

              <Box sx={{ padding: "30px 30px 30px 30px" }}>
                {previewData?.level?.map((data) => (
                  <Grid
                    container
                    sx={{
                      borderBottom: "1px solid #E5E7EB",
                      mt: 1,
                      py: 1,
                    }}
                  >
                    <Grid item xs={1}>
                      <SecondaryTypography>{data?.level}</SecondaryTypography>
                    </Grid>
                    <Grid item xs={11} sx={{ display: "flex" }}>
                      <StyledSecondaryTypography>
                        {" "}
                        {data?.area_type_id === 1
                          ? "Residential"
                          : data?.area_type_id === 2
                          ? "Non-residential"
                          : data?.area_type_id === 3
                          ? "Mixed"
                          : ""}{" "}
                        | {data?.total_unit} Units
                      </StyledSecondaryTypography>
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={11} sx={{ my: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 1.5, // uniform spacing
                          alignItems: "center",
                        }}
                      >
                        {data?.building_unit?.map((dataitm) => (
                          <Chip
                            key={dataitm.unit_no}
                            label={dataitm.unit_no}
                            variant="outlined"
                            sx={{
                              borderRadius: "8px",
                              border: "1px solid #D0D5DD",
                              fontSize: "14px",
                              fontWeight: 500,
                              minWidth: "40px",
                              textAlign: "center",
                              justifyContent: "center",
                              color: "#1E293B",
                              "& .MuiChip-label": {
                                px: 1,
                              },
                            }}
                          />
                        ))}
                      </Box>
                    </Grid>
                  </Grid>
                ))}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    borderRadius: "0px 0px 8px 8px",
                    backgroundColor: "#FFFFFF",
                    paddingTop: "24px",
                    marginTop: "20px",
                  }}
                >
                  <Button
                    onClick={() => setLevelTrigger(false)}
                    sx={{
                      borderRadius: "8px",
                      padding: "10px 16px 10px 16px",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#FFFFFF",
                      cursor: "pointer",
                      border: "none",
                      backgroundColor: "#0E5E84",
                      "&:hover": {
                        backgroundColor: "#0E4965",
                      },
                    }}
                  >
                    Close
                  </Button>
                </Box>
              </Box>
            </Box>
          </Container>
        </Modal>
      )}
      <PrimaryTypography>Property</PrimaryTypography>
      <StyledSecondaryTypography>
        Setup of building structure, including floors and units.
      </StyledSecondaryTypography>

      {buildingData?.map((value, index) => (
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            borderRadius: "8px 8px 8px 8px ",
            mt: 3,
          }}
        >
          <Box
            sx={{
              p: 2,
              borderRadius: "8px 8px 8px 8px",
              borderBottom: "1px solid #E5E7EB",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              borderTop: "1px solid #E5E7EB",
            }}
          >
            <EditBuilding
              style={{ cursor: "pointer", marginRight: "10px" }}
              onClick={() =>
                handleEditBuildingName(value?.building_name, value?.id)
              }
            />

            <SecondaryTypography> {value?.building_name} </SecondaryTypography>
          </Box>
          {value?.files ? (
            <Box sx={{ padding: "30px 16px 30px 16px" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  border: "1px solid #EAECF0",
                  borderRadius: "12px",
                  p: 2,
                  mt: 2,
                }}
              >
                <Box>
                  <Stack direction="row">
                    <ExcelIcon style={{ marginRight: "12px" }} />
                    <Stack direction="column">
                      <StyledSecondaryTypography>
                        {value?.files[0]?.name}
                      </StyledSecondaryTypography>
                      <StyledSecondaryTypography>
                        {(value?.files[0]?.size / 1048576).toFixed(2)} MB
                      </StyledSecondaryTypography>
                    </Stack>
                  </Stack>
                </Box>
                <Button
                  sx={{
                    borderRadius: "8px",
                    border: "1px solid #D2D6DB",
                    padding: "10px 16px 10px 16px",
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "#0E5E84",
                    marginRight: "1rem",
                  }}
                  onClick={() => handleEmptyReplace(value?.id)}
                >
                  Replace
                </Button>
              </Box>
              {value?.id === errId && (
                <>
                  {xlsError.split("\n").map((errorMessage, index) => (
                    <ErrorTypography style={{ marginTop: "1rem" }} key={index}>
                      {errorMessage}
                    </ErrorTypography>
                  ))}
                </>
              )}
            </Box>
          ) : value?.import_file_path ? (
            <Box sx={{ padding: "30px 16px 30px 16px" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  border: "1px solid #EAECF0",
                  borderRadius: "12px",
                  p: 2,
                  mt: 2,
                }}
              >
                <Box>
                  <Stack direction="row">
                    <ExcelIcon style={{ marginRight: "12px" }} />
                    <Stack direction="column">
                      <StyledSecondaryTypography>
                        {value?.file?.name}
                      </StyledSecondaryTypography>
                      <StyledSecondaryTypography>
                        {(value?.file?.size).toFixed(2) + "KB"}
                      </StyledSecondaryTypography>
                    </Stack>
                  </Stack>
                </Box>
                <Box>
                  <Button
                    sx={{
                      borderRadius: "8px",
                      border: "1px solid #D2D6DB",
                      padding: "10px 16px 10px 16px",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#0E5E84",
                      marginRight: "1rem",
                    }}
                    onClick={() => handleExistsEmpty(value?.id)}
                  >
                    Replace
                  </Button>

                  <Button
                    sx={{
                      backgroundColor: "#E7EFF3",
                      color: "#0E5E84",
                      "&:hover": {
                        backgroundColor: "#CFDFE6",
                      },
                    }}
                    onClick={() => handlePreviewXls(value?.id)}
                  >
                    Preview
                  </Button>
                </Box>
              </Box>
            </Box>
          ) : (
            <></>
          )}
        </Box>
      ))}
      <input
        ref={fileInputRef}
        type="file"
        onChange={handleFileInputChange}
        accept=".xlsx, .xls"
        hidden
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          p: 2,
          mt: 3,
          backgroundColor: "#FFFFFF",
        }}
      >
        <Button
          onClick={handleContinue}
          style={{
            padding: "10px 16px",
            borderRadius: "8px",
            backgroundColor: "#0E5E84",
            color: "#FFF",
            fontSize: "14px",
            fontWeight: 600,
          }}
        >
          Continue
        </Button>
      </Box>
      {editModalName && (
        <Modal open={true}>
          <Box
            sx={{
              position: "absolute",
              border: "none",
              width: "100%",
              height: "90%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                backgroundColor: "#FFFFFF",
                width: "40%",
                borderRadius: "8px",
              }}
            >
              <Box
                sx={{
                  padding: "16px 24px 16px 24px",
                  borderBottom: "1px solid #F3F4F6",
                  borderRadius: "8px 8px 0px 0px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <PrimaryTypography>Edit Building Name</PrimaryTypography>
                <Close
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setEditModalName(false);
                    setInputError("");
                  }}
                />
              </Box>
              <Box sx={{ padding: "30px 30px 30px 30px" }}>
                <Box>
                  <Box
                    sx={{
                      borderRadius: "8px",
                      marginTop: "10px",
                      marginRight: "30px",
                    }}
                  >
                    <Typography
                      style={{
                        fontWeight: 600,
                        fontSize: "14px",
                        color: "#111927",
                      }}
                    >
                      Building Name
                    </Typography>
                    <TextField
                      sx={{
                        backgroundColor: inputError ? "#FEE4E2" : "#F9FAFB",
                        "& .MuiInputBase-root": {
                          color: inputError ? "#912018" : "#111927",
                        },
                      }}
                      value={editData.building}
                      onChange={(event) => {
                        setEditData({
                          ...editData,
                          building: event.target.value,
                        });
                        setInputError("");
                      }}
                      placeholder="Enter the building name"
                      InputProps={{ disableUnderline: true }}
                      inputProps={{ maxLength: 20 }}
                      fullWidth
                    />
                    <ErrorTypography>{inputError}</ErrorTypography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderRadius: "0px 0px 8px 8px",
                    backgroundColor: "#FFFFFF",
                    paddingTop: "24px",
                    marginTop: "20px",
                  }}
                >
                  <Button
                    onClick={() => {
                      setEditModalName(false);
                      setInputError("");
                    }}
                    sx={{
                      borderRadius: "8px",
                      border: "1px solid #D2D6DB",
                      padding: "10px 16px 10px 16px",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#0E5E84",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    sx={{
                      borderRadius: "8px",
                      padding: "10px 16px 10px 16px",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#FFFFFF",
                      cursor: "pointer",
                      border: "none",
                      backgroundColor: "#0E5E84",
                      "&:hover": {
                        backgroundColor: "#0E4965",
                      },
                    }}
                    onClick={handleEditConfirm}
                  >
                    Confirm
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal>
      )}
    </>
  );
};

export default ReviewBuilding;
